import "../Tenant/tenant-form.css";

import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useSnackbar } from "material-ui-snackbar-provider";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import sourceJson from "./sourceJson";

const GET_PLATFORMSOURCES = gql`
  query PlatformSource {
    platforms {
      id
      value
      label
      status
      user
      password
    }
  }
`;

const CREATE_PLATFORM = gql`
  mutation platformsourceCreate($platformsourceInput: platformsourceInput) {
    platformsourceCreate(platformsourceInput: $platformsourceInput) {
      id
    }
  }
`;

const EyeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

function SourceAdd() {
  const snackbar = useSnackbar();
  const history = useHistory();
  const [platformsourceCreate, { loading: submitting }] = useMutation(CREATE_PLATFORM);

  const [fields, setFields] = useState({
    value: "",
    label: "",
    user: "",
    password: "",
    showPassword: false,
    isActive: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    platformsourceCreate({
      variables: {
        platformsourceInput: {
          value: fields.value,
          label: fields.label,
          status: fields.isActive,
          user: fields.user,
          password: fields.password,
        },
      },
      refetchQueries: [{ query: GET_PLATFORMSOURCES }],
      awaitRefetchQueries: true,
    })
      .then((r) => {
        if (r.data.platformsourceCreate !== undefined) {
          snackbar.showMessage("Source created");
          history.push("/managerSource");
        }
      })
      .catch(console.error);
  };

  return (
    <div className="tenant-form-page">
      {/* Header */}
      <div className="form-page-header">
        <div>
          <div className="form-breadcrumb">
            <a href="/managerSource">Sources</a>
            <span className="form-breadcrumb-sep">/</span>
            <span className="form-breadcrumb-current">New Source</span>
          </div>
          <h1 className="form-page-title">New Source</h1>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-card">
          <div className="form-card-body">
            <p className="form-section-title">Source Details</p>

            <div className="form-grid">
              {/* Source type */}
              <div className="form-group">
                <label className="form-label form-label-required" htmlFor="value">
                  Source Type
                </label>
                <select
                  className="form-select"
                  id="value"
                  name="value"
                  value={fields.value}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>Select a source type…</option>
                  {sourceJson.map(({ value, label }) => (
                    <option key={value} value={value}>{label}</option>
                  ))}
                </select>
              </div>

              {/* Label */}
              <div className="form-group">
                <label className="form-label" htmlFor="label">
                  Label
                </label>
                <input
                  className="form-input"
                  id="label"
                  name="label"
                  type="text"
                  placeholder="Display name"
                  value={fields.label}
                  onChange={handleChange}
                />
              </div>

              {/* User */}
              <div className="form-group">
                <label className="form-label" htmlFor="user">
                  User
                </label>
                <input
                  className="form-input"
                  id="user"
                  name="user"
                  type="text"
                  placeholder="API username or account ID"
                  value={fields.user}
                  onChange={handleChange}
                />
              </div>

              {/* Password */}
              <div className="form-group">
                <label className="form-label" htmlFor="password">
                  Password
                </label>
                <div className="password-wrapper">
                  <input
                    className="form-input"
                    id="password"
                    name="password"
                    type={fields.showPassword ? "text" : "password"}
                    placeholder="API key or secret"
                    value={fields.password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setFields((p) => ({ ...p, showPassword: !p.showPassword }))}
                    aria-label={fields.showPassword ? "Hide password" : "Show password"}
                  >
                    {fields.showPassword ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
              </div>
            </div>

            <div className="form-divider" />
            <p className="form-section-title">Settings</p>

            <div className="toggle-row">
              <div className="toggle-row-label">
                <span className="toggle-label-text">Active</span>
                <span className="toggle-label-desc">Source is enabled and available to tenants</span>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={fields.isActive}
                  onChange={() => setFields((p) => ({ ...p, isActive: !p.isActive }))}
                />
                <span className="toggle-track" />
                <span className="toggle-thumb" />
              </label>
            </div>
          </div>

          <div className="form-card-footer">
            <button type="button" className="btn-ghost" onClick={() => history.push("/managerSource")}>
              Cancel
            </button>
            <button type="submit" className="btn-primary-form" disabled={submitting}>
              {submitting ? "Creating…" : "Create Source"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default SourceAdd;
